/* Velvet · entrega "Chega entre [inicio] e [fim]" na página de produto (snippets/velvet-entrega.liquid) */
(function () {
  if (customElements.get('velvet-entrega')) return;

  var CHAVE_LOCAL = 'velvet_local';
  var CHAVE_IP = 'velvet_local_ip';

  var ESTADOS = {
    'acre': 'AC', 'alagoas': 'AL', 'amapa': 'AP', 'amazonas': 'AM', 'bahia': 'BA', 'ceara': 'CE',
    'distrito federal': 'DF', 'federal district': 'DF', 'espirito santo': 'ES', 'goias': 'GO',
    'maranhao': 'MA', 'mato grosso': 'MT', 'mato grosso do sul': 'MS', 'minas gerais': 'MG',
    'para': 'PA', 'paraiba': 'PB', 'parana': 'PR', 'pernambuco': 'PE', 'piaui': 'PI',
    'rio de janeiro': 'RJ', 'rio grande do norte': 'RN', 'rio grande do sul': 'RS', 'rondonia': 'RO',
    'roraima': 'RR', 'santa catarina': 'SC', 'sao paulo': 'SP', 'sergipe': 'SE', 'tocantins': 'TO'
  };

  function ler(storage, chave) {
    try {
      var valor = window[storage].getItem(chave);
      return valor ? JSON.parse(valor) : null;
    } catch (e) {
      return null;
    }
  }

  function gravar(storage, chave, valor) {
    try {
      window[storage].setItem(chave, JSON.stringify(valor));
    } catch (e) {}
  }

  function semAcento(texto) {
    return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function buscarJson(url, ms) {
    var controle = 'AbortController' in window ? new AbortController() : null;
    var timer = controle ? setTimeout(function () { controle.abort(); }, ms) : null;
    return fetch(url, controle ? { signal: controle.signal } : {})
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
      });
  }

  // Feriados nacionais (e Carnaval) em que não há entrega. Acrescentar o ano seguinte em dezembro.
  var FERIADOS = [
    '2026-01-01', '2026-02-16', '2026-02-17', '2026-04-03', '2026-04-21', '2026-05-01', '2026-06-04',
    '2026-09-07', '2026-10-12', '2026-11-02', '2026-11-20', '2026-12-25',
    '2027-01-01', '2027-02-08', '2027-02-09', '2027-03-26', '2027-04-21', '2027-05-01', '2027-05-27',
    '2027-09-07', '2027-10-12', '2027-11-02', '2027-11-15', '2027-11-20', '2027-12-25'
  ];

  // Data de entrega: hoje em São Paulo + dias úteis (sem sábado, domingo e feriado).
  function dataEntrega(dias) {
    var hoje = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date()).split('-');
    var data = new Date(Date.UTC(+hoje[0], +hoje[1] - 1, +hoje[2]));
    var contados = 0;
    while (contados < dias) {
      data.setUTCDate(data.getUTCDate() + 1);
      var semana = data.getUTCDay();
      if (semana !== 0 && semana !== 6 && FERIADOS.indexOf(data.toISOString().slice(0, 10)) === -1) contados++;
    }
    var dd = String(data.getUTCDate()).padStart(2, '0');
    var mm = String(data.getUTCMonth() + 1).padStart(2, '0');
    return dd + '/' + mm;
  }

  class VelvetEntrega extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;

      try {
        this.faixas = JSON.parse(this.querySelector('[data-velvet-faixas]').textContent);
      } catch (e) {
        this.faixas = {};
      }
      this.diasPadrao = [parseInt(this.dataset.diasMinPadrao, 10) || 10, parseInt(this.dataset.diasPadrao, 10) || 15];
      this.linha1 = this.querySelector('[data-linha1]');
      this.linha2 = this.querySelector('[data-linha2]');
      this.formCep = this.querySelector('[data-cep-form]');
      this.input = this.querySelector('[data-cep-input]');
      this.erro = this.querySelector('[data-cep-erro]');

      this.addEventListener('click', this.aoClicar.bind(this));
      this.input.addEventListener('input', this.mascarar.bind(this));
      // O campo fica dentro do form de produto: Enter não pode adicionar à sacola.
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.consultarCep();
        }
      });

      var local = ler('localStorage', CHAVE_LOCAL) || ler('sessionStorage', CHAVE_IP);
      if (local && local.uf) {
        this.mostrar(local);
      } else {
        // Sem localização: já mostra as datas do prazo padrão; o IP ou o CEP refinam depois.
        this.mostrarDatas(this.diasPadrao);
        this.localPorIp();
      }
    }

    aoClicar(e) {
      if (e.target.closest('[data-abrir-cep]')) {
        this.formCep.hidden = false;
        this.input.focus();
      } else if (e.target.closest('[data-cep-ok]')) {
        this.consultarCep();
      }
    }

    mascarar() {
      var n = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = n.length > 5 ? n.slice(0, 5) + '-' + n.slice(5) : n;
    }

    localPorIp() {
      buscarJson('https://get.geojs.io/v1/ip/geo.json', 2000)
        .then((geo) => {
          if (geo.country_code !== 'BR') return;
          var uf = ESTADOS[semAcento(geo.region)];
          if (!uf) return;
          var local = { uf: uf, cidade: geo.city || '', origem: 'ip' };
          gravar('sessionStorage', CHAVE_IP, local);
          this.mostrar(local);
        })
        .catch(function () {});
    }

    consultarCep() {
      var cep = this.input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        this.mostrarErro();
        return;
      }
      buscarJson('https://viacep.com.br/ws/' + cep + '/json/', 5000)
        .then((r) => {
          if (r.erro || !r.uf) throw new Error('cep');
          var local = { cep: cep, uf: r.uf, cidade: r.localidade || '', origem: 'cep' };
          gravar('localStorage', CHAVE_LOCAL, local);
          this.erro.hidden = true;
          this.formCep.hidden = true;
          this.mostrar(local);
        })
        .catch(() => this.mostrarErro());
    }

    mostrarErro() {
      this.erro.textContent = this.dataset.textoErro;
      this.erro.hidden = false;
    }

    mostrar(local) {
      this.mostrarDatas(this.faixas[local.uf] || this.diasPadrao);

      var lugar = [local.cidade, local.uf].filter(Boolean).join(' · ');
      var botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'velvet-entrega__link';
      botao.setAttribute('data-abrir-cep', '');
      botao.textContent = this.dataset.textoAlterar;
      this.linha2.replaceChildren(lugar + ' · ', botao);
    }

    mostrarDatas(dias) {
      var inicio = dataEntrega(dias[0]);
      var fim = dataEntrega(dias[1]);
      var titulo = document.createElement('strong');
      titulo.textContent = this.dataset.tituloComLocal
        .replace('[inicio]', inicio).replace('[fim]', fim).replace('[data]', fim)
        .replace('[min]', dias[0]).replace('[max]', dias[1]).replace('[dias]', dias[1]);
      this.linha1.replaceChildren(titulo);
      if (this.dataset.complementoComLocal) {
        this.linha1.append(' ' + this.dataset.complementoComLocal);
      }
    }
  }

  customElements.define('velvet-entrega', VelvetEntrega);
})();
